<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Zoom" class="d-icon d-icon--zoom" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="2" width="20" height="20" rx="6" :fill="`url(#${uniqueID}a)`"/><path d="M7 8.563a.625.625 0 0 0-.625.624v4.027c0 1.036.84 1.875 1.875 1.875h5.807c.345 0 .625-.28.625-.625v-4.027c0-1.035-.84-1.874-1.875-1.874H7Zm8.495 1.622a.625.625 0 0 0-.22.476v2.627c0 .183.08.357.22.476l1.568 1.337a.625.625 0 0 0 1.03-.476V9.323a.625.625 0 0 0-1.03-.475l-1.568 1.337Z" fill="#fff"/><defs><linearGradient :id="`${uniqueID}a`" x1="12" y1="2" x2="12" y2="22" gradientUnits="userSpaceOnUse"><stop stop-color="#4594FF"/><stop offset=".604" stop-color="#357CFC"/><stop offset="1" stop-color="#2C6FFA"/></linearGradient></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconZoom',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
